import { api } from './config';
import API_CONFIG from './config';

const KPI_BASE_URL = `${API_CONFIG.BASE_URL}/kpis`;

class KpiService {
  /**
   * Obtiene todos los KPIs del usuario autenticado.
   * El userId se obtiene del token JWT en el backend.
   * @returns {Promise<Object>} Objeto con las secciones y métricas de KPIs.
   */
  async getAllKpis() {
    try {
      const response = await api.get(KPI_BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Error fetching KPIs:', error);
      throw error;
    }
  }

  /**
   * Si necesitas más métodos para KPIs específicos,
   * agrégalos aquí, por ejemplo:
   * 
   * async getKpiById(kpiId) {...}
   * async compareKpis(userId1, userId2) {...}
   */
}

// Creamos una instancia y la asignamos a una variable
const kpiServiceInstance = new KpiService();

// Exportamos la instancia única del servicio
export default kpiServiceInstance;